import { Entity } from '@adornis/baseql/decorators.js';
import { ExportDataView } from '@adornis/data-view/db/export-data-view.js';
import { dataViewTranslations } from '@adornis/data-view/default-translations.js';
import { formatCalendarDay } from '@adornis/datetime/calendarDay.js';
import { Language } from '@adornis/translation-core/languages.js';
import { Translator } from '@adornis/translation-core/translation.js';
import { languages, translationDict } from '../../db/translation-dict.js';

@Entity()
export class UserExport extends ExportDataView {
  static override _class = 'UserExport';

  /**
   * The export runs on the server, where the app dictionary is never loaded into the client translator,
   * and the base translator only knows the data-view labels - without this every header was a raw field key.
   */
  static override _translator = new Translator({
    dictionary: { ...dataViewTranslations, ...translationDict },
    languages,
    getSelectedLanguage: () => Language.GERMAN,
    selectLanguage: () => {},
  });

  static override translateValue(key: string, value: any) {
    if (typeof value === 'number') value = value.toLocaleString(this._language === 'de' ? 'de-DE' : 'en-EN');

    if (value instanceof Date) {
      value = formatCalendarDay(value, this._language === 'de' ? 'dd.MM.yyyy' : 'MM/dd/yyyy');
    }
    return value;
  }
}
